import authHeader from "./auth-header";

export const apiCall = async (url, method = "get", body = {}, extraHeaders = null) => {

  let headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };
  if (extraHeaders) {
    headers = { ...headers, ...extraHeaders };
  }

  const fetchConfig = {
    method: method.toUpperCase(),
    headers: new Headers(headers),
    withCredentials: true
  };

  if (method.toLowerCase() !== "get" && Object.keys(body).length !== 0)
    fetchConfig.body = JSON.stringify(body);

  try {
    const response = await fetch(url, fetchConfig);
    
    switch (response.status) {
      case 200:
        return await response.json();
      case 401:
        throw new Error(`Authentication failed at ${url}`);
      case 403:
        throw new Error(`Access forbidden at ${url}`);
      case 404:
        throw new Error(`Resource not found at ${url}`);
      case 500:
      case 502:
      case 503:
      case 504:
        throw new Error(`Server error (${response.status}) at ${url}`);
      default:
        throw new Error(`HTTP ${response.status} at ${url}`);
    }
  } catch (error) {
    // Network-level errors (CORS, DNS, connection refused, etc.)
    if (error.message.includes('Failed to fetch')) {
      console.error('Network error:', {
        url,
        method,
        error: 'Failed to fetch - possible CORS, network, or DNS issue',
        online: window.navigator.onLine
      });
      throw new Error(`Network error: Unable to reach server at ${url}`);
    }
    // Re-throw other errors (HTTP status errors from above)
    throw error;
  }
};

export const authApiCall = async (url, method = "get", body = {}, extraHeaders = null) => {

  let headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
  };
  headers = { ...headers, ...authHeader() };
  if (extraHeaders) {
    headers = { ...headers, ...extraHeaders };
  }

  const fetchConfig = {
    method: method.toUpperCase(),
    headers: new Headers(headers),
    withCredentials: true
  };

  if (method.toLowerCase() !== "get" && Object.keys(body).length !== 0)
    fetchConfig.body = JSON.stringify(body);

  try {
    const response = await fetch(url, fetchConfig);
    
    switch (response.status) {
      case 200:
        return await response.json();
      case 401:
        // Authentication error - token may be expired
        throw new Error(`Authentication failed at ${url}`);
      case 403:
        // Permission denied
        throw new Error(`Access forbidden at ${url}`);
      case 404:
        // Not found
        throw new Error(`Resource not found at ${url}`);
      case 500:
      case 502:
      case 503:
      case 504:
        // Server errors
        throw new Error(`Server error (${response.status}) at ${url}`);
      default:
        throw new Error(`HTTP ${response.status} at ${url}`);
    }
  } catch (error) {
    // Network-level errors (CORS, DNS, connection refused, etc.)
    if (error.message.includes('Failed to fetch')) {
      console.error('Network error:', {
        url,
        method,
        error: 'Failed to fetch - possible CORS, network, or DNS issue',
        online: window.navigator.onLine
      });
      throw new Error(`Network error: Unable to reach server at ${url}`);
    }
    // Re-throw other errors (HTTP status errors from above)
    throw error;
  }
};
